import { StatusEnum } from "../generated/graphql";

export const PRINT_URL_MISSING_MESSAGE =
  "印刷用PDFを取得できませんでした。しばらく経ってから再度印刷データを送信してください。";
export const PDF_GENERATION_FAILED_MESSAGE =
  "PDFの生成に失敗しました。ネットワーク接続を確認のうえ、再度印刷データを送信してください";

export const getPrintUrlMissingErrorMessage = (status: StatusEnum): string => {
  if (status === StatusEnum.Error) {
    return PDF_GENERATION_FAILED_MESSAGE;
  }
  return PRINT_URL_MISSING_MESSAGE;
};

export const isPrintJobError = (status: StatusEnum): boolean =>
  status === StatusEnum.Error;
